<!--  -->
<template>
  <div class="container">
    <div class="box"><img src="~@/assets/images/ad/ad2/17.png" alt="" /></div>
    <div class="box">
      <img src="~@/assets/images/ad/ad2/18.png" alt="" />
      <div class="wrap">
        <ul class="list">
          <li v-for="(item, index) in list" :key="index">
            <a :href="item.url" target="_blank">
              <div class="info">
                <div class="info-item flex flex-between pt-26">
                  <div class="name">{{ item.name }}</div>
                  <div class="price">{{ item.price }}</div>
                </div>
                <div class="info-item flex pt-20">
                  <div class="address flex">
                    <img src="~@/assets/images/ad/ad2/20.png" alt="" />
                    <span>{{ item.address }}</span>
                  </div>
                  <div class="role">{{ item.role }}</div>
                </div>
              </div>
            </a>
          </li>
        </ul>
      </div>
    </div>
    <div class="box"><img src="~@/assets/images/ad/ad2/19.png" alt="" /></div>

    <div class="btn-box">
      <div class="btn share_bt">分享</div>
    </div>
    <div class="v4">
      <img
        v-if="showDownLoad"
        src="~@/assets/images/ad/ad2/5.png"
        alt=""
        class="v4_1"
        @click="onDownload"
      />
    </div>
  </div>
</template>

<script>
import { h5 } from "@/utils/env";
import { initShare, getWXEvn, isBangBangApp, isWeixin } from "@/utils";
export default {
  //import引入的组件需要注入到对象中才能使用
  components: {},
  data() {
    //这里存放数据
    return {
      initShareObg: {},
      list: [
        {
          name: "网络工程师（CT产品方向）",
          price: "8-10k",
          address: "福建省福州市",
          role: "初级",
          url: "https://www.wjx.top/vj/w8Dh0pB.aspx",
        },
        {
          name: "网络工程师（极光解决方案）",
          price: "8-10k",
          address: "福建省福州市",
          role: "初级",
          url: "https://www.wjx.top/vj/w8Dh0pB.aspx",
        },
        {
          name: "网络通信工程师（5G小站方向）",
          price: "8-10k",
          address: "福建省福州市",
          role: "初级",
          url: "https://www.wjx.top/vj/w8Dh0pB.aspx",
        },
        {
          name: "售前测试工程师",
          price: "8-10k",
          address: "福建省福州市",
          role: "初级",
          url: "https://www.wjx.top/vj/w8Dh0pB.aspx",
        },
        {
          name: "网络工程师",
          price: "18k以内",
          address: "上海市",
          role: "高级",
          url: "https://www.wjx.top/vj/w8Dh0pB.aspx",
        },
        {
          name: "网络工程师",
          price: "8-10k",
          address: "浙江省金华市",
          role: "初级",
          url: "https://www.wjx.top/vj/w8Dh0pB.aspx",
        },
        {
          name: "网络工程师",
          price: "10-15k",
          address: "浙江省宁波市",
          role: "高级",
          url: "https://www.wjx.top/vj/w8Dh0pB.aspx",
        },
        {
          name: "网络工程师",
          price: "9-11k",
          address: "吉林省长春市",
          role: "中级",
          url: "https://www.wjx.top/vj/w8Dh0pB.aspx",
        },
        {
          name: "服务器工程师",
          price: "5-7k",
          address: "江西省南昌市",
          role: "初级",
          url: "https://www.wjx.top/vj/w8Dh0pB.aspx",
        },
        {
          name: "网络工程师",
          price: "10-15k",
          address: "浙江省杭州市",
          role: "高级",
          url: "https://www.wjx.top/vj/w8Dh0pB.aspx",
        },
        {
          name: "销售",
          price: "6-7k",
          address: "广西省南宁市",
          role: "初级",
          url: "https://www.wjx.top/vj/w8Dh0pB.aspx",
        },

        {
          name: "网络工程师",
          price: "8-10K",
          address: "北京市",
          role: "初级",
          url: "https://www.wjx.top/vj/w8Dh0pB.aspx",
        },

        {
          name: "技术支持",
          price: "8-10K",
          address: "杭州市",
          role: "初级",
          url: "https://www.wjx.top/vj/w8Dh0pB.aspx",
        },

        {
          name: "运维工程师",
          price: "6-8K",
          address: "北京市",
          role: "初级",
          url: "https://www.wjx.top/vj/w8Dh0pB.aspx",
        },

        {
          name: "运维工程师",
          price: "7-9K",
          address: "北京市",
          role: "初级",
          url: "https://www.wjx.top/vj/w8Dh0pB.aspx",
        },

        {
          name: "服务器存储工程师",
          price: "8-10K",
          address: "上海市",
          role: "初级",
          url: "https://www.wjx.top/vj/w8Dh0pB.aspx",
        },

        {
          name: "网络工程师",
          price: "5-7K",
          address: "河南省郑州市",
          role: "初级",
          url: "https://www.wjx.top/vj/w8Dh0pB.aspx",
        },

        {
          name: "网络工程师",
          price: "10-12K",
          address: "上海市",
          role: "初中级",
          url: "https://www.wjx.top/vj/w8Dh0pB.aspx",
        },
      ],
      showDownLoad: true,
    };
  },
  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {},
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {
    if (isWeixin()) {
      getWXEvn({
        //如果是小程序
        isMiniApp: () => {
          this.showDownLoad = false;
        },
        //如果是公众号网页
        isWeixinNotMiniApp: () => {},
      });
    } else if (isBangBangApp()) {
      this.showDownLoad = false;
    }
  },
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
    this.initShareObg = new initShare({
      shareUrl: `${h5}app/v2/active/active5.html`,
      sharePath: "commonh5",
      imgUrl: "https://static.shenzhoubb.com/images/miniapp/share1.png",
      miniAppImgUrl: "https://static.shenzhoubb.com/images/miniapp/share.png",
      title: "最近1天，高薪急聘工程师岗位",
      desc: "我发现了适合你的高薪岗位，推荐你报名，快来报名吧！下载神州邦邦app，或微信小程序搜索“神州邦邦”发现更多工程师高薪岗位！",
    });
  },
  beforeCreate() {}, //生命周期 - 创建之前
  beforeMount() {}, //生命周期 - 挂载之前
  beforeUpdate() {}, //生命周期 - 更新之前
  updated() {}, //生命周期 - 更新之后
  beforeDestroy() {}, //生命周期 - 销毁之前
  destroyed() {}, //生命周期 - 销毁完成
  activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
  //方法集合
  methods: {
    onDownload() {
      // location.href = `${h5}app/callApp.html`;
      location.href = `${h5}app/install.html?source=ENGINEER`;
    },
  },
};
</script>
<style lang='less' scoped>
//@import url(); 引入公共css类
.box {
  position: relative;
  box-sizing: border-box;
  width: 7.5rem;
  margin: 0 auto;

  img {
    display: block;
    width: 100%;
  }
}

.wrap {
  position: absolute;
  top: 1.33rem;
  left: 0;
  right: 0;
  bottom: 0;
}

.list {
  box-sizing: border-box;
  width: 7.5rem;
  padding: 0 0.68rem;
  margin: 0 auto;

  li {
    box-sizing: border-box;
    width: 100%;
    height: 1.31rem;

    &:not(:last-child) {
      margin-bottom: 0.23rem;
    }

    a {
      display: block;
      width: 100%;
      height: 100%;
    }
  }
}

.info {
  box-sizing: border-box;
  width: 100%;

  &-item {
    box-sizing: border-box;
    width: 100%;
    padding: 0 0.5rem 0 0.4rem;
  }

  .name {
    font-size: 0.26rem;
    font-family: AlibabaPuHuiTi-Medium, AlibabaPuHuiTi;
    font-weight: 500;
    color: #353232;
    line-height: 0.35rem;
    letter-spacing: 2px;
  }

  .price {
    font-size: 0.24rem;
    font-family: AlibabaPuHuiTi-Medium, AlibabaPuHuiTi;
    font-weight: 500;
    color: #fb4529;
    line-height: 0.33rem;
    letter-spacing: 2px;
  }

  .address {
    img {
      width: 0.2rem;
      height: 0.25rem;
      vertical-align: middle;
      object-fit: contain;
    }

    span {
      display: inline-block;
      white-space: nowrap;
      width: 1.26rem;
      margin-left: 0.04rem;
      font-size: 0.2rem;
      font-family: AlibabaPuHuiTi-Regular, AlibabaPuHuiTi;
      font-weight: 400;
      color: #595353;
      line-height: 0.27rem;
      letter-spacing: 1px;
    }
  }

  .role {
    margin-left: 0.38rem;
    font-size: 0.2rem;
    font-family: AlibabaPuHuiTi-Regular, AlibabaPuHuiTi;
    font-weight: 400;
    color: #595353;
    line-height: 0.27rem;
    letter-spacing: 1px;
  }
}

.pt-26 {
  padding-top: 0.26rem;
}
.pt-20 {
  padding-top: 0.2rem;
}

.flex {
  display: flex;
  align-items: center;
}

.flex-between {
  justify-content: space-between;
}

.btn-box {
  box-sizing: border-box;
  width: 100%;
  padding: 0.14rem 0;

  .btn {
    width: 6.8rem;
    margin: 0 auto;
    height: 0.8rem;
    background: linear-gradient(180deg, #fd7c32 0%, #fb4529 100%);
    box-shadow: 0px 0.04rem 0.02rem 0px #e32204;
    border-radius: 0.42rem;
    text-align: center;
    font-size: 0.3rem;
    font-family: AlibabaPuHuiTi-Medium, AlibabaPuHuiTi;
    font-weight: 500;
    color: #fff2a3;
    line-height: 0.8rem;
    text-shadow: 0rem 0.03rem 0rem #ec1f00;
  }
}
.v4 {
  position: absolute;
  top: 2rem;
  width: 1.5rem;
  right: -0.49rem;
  .v4_1,
  .share_bt {
    width: 1.5rem;
  }
  .share_bt {
    margin-top: -0.55rem;
  }
}
</style>